export default "__VITE_ASSET__CAx8VoXG__"